import { EvaChartStates } from "types/factory";

import { DataEnum } from "models";

import { convertToNumber } from "./utils/convertToNumber";

/**
 * Rig/Frac Activity Over Time (EVA-76 #6, #2b): Y-AXIS user locks on BOTH the
 * bars (primary y) axis and the Frac Crew Count (right/y2) axis.
 *
 * The chart's x-axis is a category axis of server-computed date buckets and the
 * date WINDOW is driven by the time-scale / custom-range selector, so there are
 * NO x/date locks. Only the user's explicit min/max pass through; everything
 * else is left undefined so the translator falls back to the data-derived
 * bounds.
 */
export function rigFracActivityLocks(states: Partial<EvaChartStates>) {
  const { locks } = states;

  const isUserLock = (lock: Maybe<{ type?: string; value?: unknown }>) =>
    lock?.type !== DataEnum.Reset && lock?.value !== undefined;

  const isUserYMinLock = isUserLock(locks?.yMin);
  const isUserYMaxLock = isUserLock(locks?.yMax);
  const isUserY2MinLock = isUserLock(locks?.y2Min);
  const isUserY2MaxLock = isUserLock(locks?.y2Max);

  return {
    lockedXMin: undefined,
    lockedXMax: undefined,
    lockedYMin: convertToNumber(isUserYMinLock ? locks?.yMin?.value : undefined),
    lockedYMax: convertToNumber(isUserYMaxLock ? locks?.yMax?.value : undefined),
    lockedYMinType: isUserYMinLock ? locks?.yMin?.type : undefined,
    lockedYMaxType: isUserYMaxLock ? locks?.yMax?.type : undefined,
    lockedY2Min: convertToNumber(isUserY2MinLock ? locks?.y2Min?.value : undefined),
    lockedY2Max: convertToNumber(isUserY2MaxLock ? locks?.y2Max?.value : undefined),
    lockedY2MinType: isUserY2MinLock ? locks?.y2Min?.type : undefined,
    lockedY2MaxType: isUserY2MaxLock ? locks?.y2Max?.type : undefined
  };
}
